"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useStickyElement", {
    enumerable: true,
    get: function() {
        return useStickyElement;
    }
});
const _react = require("react");
const _StickyContext = require("./StickyContext");
const useStickyElement = function() {
    let { enabled = true, stack = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const ref = (0, _react.useRef)(null);
    const [isStuck, setIsStuck] = (0, _react.useState)(false);
    const sticky = (0, _react.useContext)(_StickyContext.StickyContext);
    const [top, setTop] = (0, _react.useState)(0);
    (0, _react.useEffect)(()=>{
        if (!enabled) {
            return undefined;
        }
        setTop(sticky.push(ref, {
            shouldStack: stack
        }).top);
        return ()=>{
            sticky.pop(ref);
        };
    }, [
        sticky,
        stack,
        enabled,
        ref
    ]);
    (0, _react.useEffect)(()=>{
        if (!enabled) {
            return undefined;
        }
        if (ref.current != null) {
            var _sticky_rootRef;
            var _sticky_rootRef_current;
            const observer = new IntersectionObserver((entries)=>{
                setIsStuck(entries[0].rootBounds != null ? entries[0].boundingClientRect.y < entries[0].rootBounds.y : entries[0].intersectionRatio < 1);
            }, {
                threshold: 1,
                rootMargin: "".concat(0 - (top + 1), "px 0px 0px 0px"),
                root: (_sticky_rootRef_current = (_sticky_rootRef = sticky.rootRef) === null || _sticky_rootRef === void 0 ? void 0 : _sticky_rootRef.current) !== null && _sticky_rootRef_current !== void 0 ? _sticky_rootRef_current : undefined
            });
            observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
        return undefined;
    }, [
        enabled,
        ref,
        sticky.rootRef,
        top
    ]);
    return {
        ref,
        top,
        isStuck
    };
};

//# sourceMappingURL=useStickyElement.js.map